import trainingMaterialsModule from '@/utils/pageParams/trainingMaterials.js'
import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'

const base = trainingMaterialsModule.trainingMaterials

/** 超管资料库：管理系统内置 + 全部机构资料 */
const materialLibrary = {
  materialLibrary: {
    ...base,
    name: 'materialLibrary',
    materialLearnRecords: trainingMaterialsModule.materialLearnRecords,
    addFun: 'training/addTrainingMaterials',
    editFun: 'training/editTrainingMaterials',
    getListFun: 'training/getTrainingMaterialsList',
    deleteFun: 'training/deleteTrainingMaterials',
    detailPage: [
      {
        buttonName: '新增',
        name: 'materialLibrary',
        type: 'stepForm',
        theme: 'materialLibrary',
        step: 'materialLibraryInfo',
        label: '新增资料库资料'
      },
      {
        buttonNames: ['编辑', '查看'],
        name: 'materialLibrary',
        type: 'stepForm',
        theme: 'materialLibrary',
        step: 'materialLibraryInfo',
        label: '编辑资料库资料',
        checkType: 'checkByUid',
        checkFun: 'training/getTrainingMaterialsInfo'
      },
      {
        buttonName: '浏览量',
        type: 'drawerTable',
        name: 'materialLearnRecords',
        checkType: 'checkByUid',
        checkFun: 'training/getMaterialLearnRecords'
      },
      {
        buttonName: '关联文件',
        name: 'previewMaterials',
        type: 'preview',
        theme: 'preview',
        step: 'previewInfo',
        label: (params) => {
          if (!params.currentRow) return '预览或查看文件'
          if (params.currentRow.dataFormat === 'article') {
            return '查看图文：' + params.currentRow.dataName
          }
          return (
            (params.currentRow.dataFormat === 'video' ? '播放：' : '预览：') +
            params.currentRow.dataName
          )
        },
        previewParams: (params) => {
          if (!params.currentRow || params.currentRow.dataFormat === 'article') {
            return null
          }
          return {
            key: 'trainingMaterials',
            uid: params.currentRow.associatedFiles,
            type: params.currentRow.dataFormat,
            name: params.currentRow.dataName
          }
        }
      },
      {
        buttonName: '预览或下载文件',
        name: 'previewMaterials',
        type: 'preview',
        theme: 'preview',
        step: 'previewInfo',
        label: (params) => {
          if (!params.formValues) return '预览或查看文件'
          if (params.formValues.dataFormat === 'article') {
            return '查看图文：' + params.formValues.dataName
          }
          return (
            (params.formValues.dataFormat === 'video' ? '播放：' : '预览：') +
            params.formValues.dataName
          )
        },
        previewParams: (params) => {
          if (!params.formValues || params.formValues.dataFormat === 'article') {
            return null
          }
          return {
            key: 'trainingMaterials',
            uid: params.formValues.associatedFiles,
            type: params.formValues.dataFormat,
            name: params.formValues.dataName
          }
        }
      }
    ],
    headButtons: setCheckButtons(['新增']),
    queryParams: {
      orgUid: () => '',
      scope: 'all',
      dataType: [],
      applicableUsers: [],
      dataFormat: '',
      query: '',
      usageCount: null,
      pageviews: null
    },
    rowData: (params) => {
      return params.state.training.trainingMaterials.result
    },
    rowTotal: (params) => {
      return params.state.training.trainingMaterials.totalSize
    },
    columns: [
      {
        prop: 'dataName',
        label: '资料名称',
        minWidth: '220px',
        overflow: false,
        overflowWidth: true
      },
      {
        prop: 'dataAccess',
        label: '资料权限',
        width: '90px',
        tag: (params) => {
          return params.dictionarys.access
        }
      },
      { prop: 'learningTime', label: '学习课时', width: '90px' },
      { prop: 'usageCount', label: '使用次数', width: '90px' },
      { prop: 'pageviews', label: '浏览量', width: '90px', drillDown: true },
      {
        prop: 'dataFormatName',
        label: '资料格式',
        width: '100px',
        tag: (params) => {
          return params.dictionarys.dataFormat
        }
      },
      {
        prop: 'files',
        label: '关联文件',
        width: '90px',
        isIdeal: '预览或下载',
        drillDown: true
      },
      {
        prop: 'dataLabelTags',
        label: '资料类型及标签',
        minWidth: '240px',
        tagList: true
      },
      {
        prop: 'applicableUserTags',
        label: '适用对象',
        minWidth: '200px',
        tagList: true
      },
      {
        prop: 'createOrgName',
        label: '创建机构',
        width: '110px',
        overflow: false,
        overflowWidth: true
      },
      { prop: 'creatorName', label: '创建人', width: '100px' },
      {
        label: '操作',
        width: '220px',
        buttons: setTableButtons(['查看', '编辑', '删除'])
      }
    ],
    formParams: {
      ...base.formParams,
      orgUid: () => '',
      dataAccess: '公开'
    },
    formData: {
      ...base.formData,
      card: '资料库资料信息',
      bottomButtons: setFormButtons(['取消', '提交'])
    }
  },
  materialLearnRecords: trainingMaterialsModule.materialLearnRecords
}

export default materialLibrary
